import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { getQaSelector } from '../../../utils/common'
import ButtonComponent from '../../Button'
import { ClampingTextContentCSSClamp } from '../ClampingTextContentCSSClamp'
import { ClampingTextNodeContent } from '../ClampingTextNodeContent'

import {
  CLAMPING_LINES_COUNT,
  EXPAND_BUTTON_HEIGHT,
} from './ClampingText.constants'

import * as styles from './ClampingText.module.css'

function ClampingText({
  Button = ButtonComponent.Contained,
  buttonClassName,
  buttonHeight = EXPAND_BUTTON_HEIGHT,
  clampingConfig,
  clampingLinesCount = CLAMPING_LINES_COUNT,
  containerClassName,
  fullText,
  isGreyButton = true,
  isNodeClamp,
  qaName,
  textClassName,
}) {
  const { t } = useTranslation()

  const [clamped, setClamped] = useState(true)

  const [showExpandButton, setShowExpandButton] = useState(false)

  function handleClickButton() {
    setClamped(prev => !prev)
  }

  const showMoreClassName = classNames(styles.showMore, buttonClassName)

  return (
    <>
      <div
        {...(qaName ? getQaSelector({ value: qaName }) : null)}
        className={containerClassName}
      >
        {isNodeClamp ? (
          <ClampingTextNodeContent
            {...clampingConfig}
            clamped={clamped}
            clampingLinesCount={clampingLinesCount}
            fullText={fullText}
            setShowExpandButton={setShowExpandButton}
            textClassName={textClassName}
          />
        ) : (
          <ClampingTextContentCSSClamp
            clamped={clamped}
            clampingLinesCount={clampingLinesCount}
            classNameText={textClassName}
            fullText={fullText}
            setShowExpandButton={setShowExpandButton}
          />
        )}
      </div>

      {showExpandButton && Button ? (
        <Button
          className={showMoreClassName}
          height={buttonHeight}
          isGrey={isGreyButton}
          text={
            clamped
              ? t('Notification.CommonReadMoreBtnKey')
              : t('Notification.CommonReadLessBtnKey')
          }
          onClick={handleClickButton}
        />
      ) : null}
    </>
  )
}

export default ClampingText
